import React from "react";

import { BorderedBlock } from "../../../../../../features/common-attributes/components/bordered-block/bordered-block.component";
import { RichTextField } from "../../../../../../features/forms/fields/rich-text-field/components/rich-text-field/rich-text-field.component";
import { TemplateName } from "../../../../../../types/templates/template-name";

import { CbTemplateControlProps } from "../../../../types/cb-template-control-props/cb-template-control.props";

export const CbTemplateControlBackground = (props: CbTemplateControlProps) => (
  <BorderedBlock>
    <RichTextField
      form={props.form}
      label="Background"
      name="background"
      required
      subTitle={TemplateName.CampaignBrief.NewProductLaunch}
      userPermissions={props.userPermissions}
    />
  </BorderedBlock>
);
